import React from "react";
import { Form, Input, Radio, InputNumber } from "antd";

export default function GolfHistorySection() {
  return (
    <div className="golf-history-section">
      <h3>ประวัติการเล่นกอล์ฟ (Golf History)</h3>

      {/* Club Membership - Requirement 5.1 */}
      <Form.Item
        name="clubMembership"
        label="สมาชิกสนามกอล์ฟ (Golf Club/Course Membership)"
        rules={[
          { max: 200, message: "กรุณากรอกไม่เกิน 200 ตัวอักษร" },
        ]}
      >
        <Input maxLength={200} placeholder="ชื่อสนามกอล์ฟและที่ตั้ง" />
      </Form.Item>

      {/* Professional Golfer - Requirement 5.2 */}
      <Form.Item
        name="isProfessional"
        label="เป็นนักกอล์ฟอาชีพหรือไม่ (Professional Golfer)"
        initialValue={false}
      >
        <Radio.Group>
          <Radio value={true}>ใช่ (Yes)</Radio>
          <Radio value={false}>ไม่ใช่ (No)</Radio>
        </Radio.Group>
      </Form.Item>

      {/* Existing Insurance - Requirement 5.3 */}
      <Form.Item
        name="hasExistingInsurance"
        label="มีประกันภัยกอล์ฟกับบริษัทอื่นหรือไม่ (Existing Golfer Insurance)"
        initialValue={false}
      >
        <Radio.Group>
          <Radio value={true}>ใช่ (Yes)</Radio>
          <Radio value={false}>ไม่ใช่ (No)</Radio>
        </Radio.Group>
      </Form.Item>

      {/* Conditional fields for existing insurance - Requirement 5.4 */}
      <Form.Item noStyle shouldUpdate={(prev, cur) => prev.hasExistingInsurance !== cur.hasExistingInsurance}>
        {({ getFieldValue }) =>
          getFieldValue("hasExistingInsurance") === true ? (
            <>
              <Form.Item
                name="existingInsuranceCompany"
                label="ชื่อบริษัทประกันภัย (Insurance Company Name)"
                rules={[
                  { required: true, message: "กรุณากรอกชื่อบริษัทประกันภัย" },
                  { max: 100, message: "กรุณากรอกไม่เกิน 100 ตัวอักษร" },
                ]}
              >
                <Input maxLength={100} placeholder="ชื่อบริษัทประกันภัย" />
              </Form.Item>
              <Form.Item
                name="existingInsuranceSumInsured"
                label="ทุนประกันภัย (Sum Insured)"
                rules={[
                  { required: true, message: "กรุณากรอกทุนประกันภัย" },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  maxLength={10}
                  placeholder="จำนวนเงินทุนประกันภัย"
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  parser={(value) => value.replace(/,/g, "")}
                />
              </Form.Item>
            </>
          ) : null
        }
      </Form.Item>

      {/* Previous Refusal/Cancellation - Requirement 5.5 */}
      <Form.Item
        name="hasPreviousRefusal"
        label="เคยถูกปฏิเสธหรือยกเลิกประกันภัยหรือไม่ (Previous Refusal/Cancellation)"
        initialValue={false}
      >
        <Radio.Group>
          <Radio value={true}>ใช่ (Yes)</Radio>
          <Radio value={false}>ไม่ใช่ (No)</Radio>
        </Radio.Group>
      </Form.Item>

      {/* Conditional field for previous refusal - Requirement 5.6 */}
      <Form.Item noStyle shouldUpdate={(prev, cur) => prev.hasPreviousRefusal !== cur.hasPreviousRefusal}>
        {({ getFieldValue }) =>
          getFieldValue("hasPreviousRefusal") === true ? (
            <Form.Item
              name="previousRefusalCompany"
              label="ชื่อบริษัทประกันภัย (Insurance Company Name)"
              rules={[
                { required: true, message: "กรุณากรอกชื่อบริษัทประกันภัย" },
                { max: 100, message: "กรุณากรอกไม่เกิน 100 ตัวอักษร" },
              ]}
            >
              <Input maxLength={100} placeholder="ชื่อบริษัทประกันภัยที่ปฏิเสธ/ยกเลิก" />
            </Form.Item>
          ) : null
        }
      </Form.Item>
    </div>
  );
}
